<template>
    <div class="u-mt-20" style="padding: 20px 12px;">
        <h4>Mensagens</h4>
        <p style="color:#909399;">Converse com os professores da sua turma <strong>{{ $store.state.user.turma_nome }}</strong>.</p>

        <div class="msg-barra">
            <el-radio-group v-model="aba" size="small" @change="load">
                <el-radio-button label="entrada">
                    Recebidas <el-badge v-if="naoLidas > 0" :value="naoLidas" type="danger" />
                </el-radio-button>
                <el-radio-button label="saida">Enviadas</el-radio-button>
            </el-radio-group>
            <el-button type="primary" size="small" icon="el-icon-edit-outline" class="msg-btn-nova" @click="abrirNova">NOVA MENSAGEM</el-button>
        </div>

        <div class="msg-lista">
            <div v-for="m in items" :key="m.id" class="msg-item"
                 :class="{ 'msg-nao-lida': !m.lida_at && aba === 'entrada' }" @click="abrirLeitura(m)">
                <div class="msg-item-icone">
                    <i v-if="aba === 'entrada' && !m.lida_at" class="el-icon-message-solid" style="color:#409eff;"></i>
                    <i v-else class="el-icon-message" style="color:#c0c4cc;"></i>
                </div>
                <div class="msg-item-conteudo">
                    <div class="msg-item-topo">
                        <span class="msg-item-pessoa">{{ pessoa(m) }}</span>
                        <span class="msg-item-data">{{ m.created_at | formatarDt }}</span>
                    </div>
                    <div class="msg-item-assunto">{{ m.assunto }}</div>
                </div>
            </div>
            <div v-if="!items.length" class="msg-vazio">
                {{ aba === 'entrada' ? 'Nenhuma mensagem recebida.' : 'Nenhuma mensagem enviada.' }}
            </div>
        </div>

        <!-- Leitura -->
        <el-dialog title="" :visible.sync="modalLeituraVisivel" width="640px" custom-class="msg-dialog">
            <div v-if="msgAtual">
                <h3 style="margin-top:0;">{{ msgAtual.assunto }}</h3>
                <p style="color:#909399;">
                    <strong>De:</strong> {{ nomeRemetente(msgAtual) }}
                    | <strong>Para:</strong> {{ nomeDestinatario(msgAtual) }}
                    | {{ msgAtual.created_at | formatarDt }}
                </p>
                <hr/>
                <div style="white-space:pre-wrap; padding:8pt 0;">{{ msgAtual.corpo }}</div>
                <div v-if="msgAtual.respostas && msgAtual.respostas.length">
                    <hr/>
                    <h4 style="color:#606266;">Respostas</h4>
                    <div v-for="r in msgAtual.respostas" :key="r.id" style="margin-bottom:8pt; padding:8pt; background:#f4f4f5; border-radius:4px;">
                        <p style="margin:0; color:#909399; font-size:12px;">{{ nomeRemetente(r) }} — {{ r.created_at | formatarDt }}</p>
                        <div style="white-space:pre-wrap;">{{ r.corpo }}</div>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <el-button @click="modalLeituraVisivel = false">FECHAR</el-button>
                <el-button v-if="msgAtual && aba === 'entrada'" type="primary" @click="abrirResposta">RESPONDER</el-button>
            </span>
        </el-dialog>

        <!-- Nova / resposta -->
        <el-dialog :title="form.parent_id ? 'Responder' : 'Nova mensagem'" :visible.sync="modalNovaVisivel" width="560px" custom-class="msg-dialog">
            <el-form label-position="top" :model="form" ref="formRef">
                <el-form-item label="Professor" prop="destinatario_user_id" :rules="[$requiredChange]">
                    <el-select v-model="form.destinatario_user_id" placeholder="Selecione o professor"
                        filterable style="width:100%;" :disabled="!!form.parent_id" :loading="loadProf">
                        <el-option v-for="p in professores" :key="p.id" :label="p.name" :value="p.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Assunto" prop="assunto" :rules="[$requiredBlur]">
                    <el-input v-model="form.assunto" maxlength="255" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="Mensagem" prop="corpo" :rules="[$requiredBlur]">
                    <el-input type="textarea" v-model="form.corpo" :rows="6"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="modalNovaVisivel = false">CANCELAR</el-button>
                <el-button type="primary" @click="enviar">ENVIAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarDt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '' } },
    data () {
        return {
            aba: 'entrada',
            items: [], naoLidas: 0,
            modalLeituraVisivel: false, msgAtual: null,
            modalNovaVisivel: false,
            professores: [], loadProf: false,
            form: this.formVazio()
        }
    },
    mounted () { this.load(); this.contarNaoLidas() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        formVazio () { return { destinatario_user_id: '', assunto: '', corpo: '', parent_id: null } },

        nomeRemetente (m) {
            if (m.remetente_tipo === 'aluno') return (m.remetente_aluno ? m.remetente_aluno.nome : 'Você')
            return m.remetente ? m.remetente.name : '?'
        },
        nomeDestinatario (m) {
            if (m.destinatario_user) return m.destinatario_user.name
            if (m.destinatario_aluno) return m.destinatario_aluno.nome
            return '—'
        },
        pessoa (m) {
            return this.aba === 'entrada' ? this.nomeRemetente(m) : this.nomeDestinatario(m)
        },

        load () {
            const ep = this.aba === 'entrada' ? 'caixa-entrada' : 'caixa-saida'
            this.$axios.post(`${this.baseUrl()}/api/portal/mensagem/${ep}`, {}, this.$store.getters.getHeaderAuth)
                .then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
                .catch(e => this.$store.commit('throwException', e))
        },
        contarNaoLidas () {
            this.$axios.post(`${this.baseUrl()}/api/portal/mensagem/nao-lidas`, {}, this.$store.getters.getHeaderAuth)
                .then(r => { this.naoLidas = (r.data && r.data.total) || 0 })
                .catch(() => { this.naoLidas = 0 })
        },

        abrirLeitura (m) {
            this.$axios.post(`${this.baseUrl()}/api/portal/mensagem/get-by-id/${m.id}`, {}, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                this.msgAtual = r.data || null
                this.modalLeituraVisivel = true
                if (this.aba === 'entrada' && this.msgAtual && !this.msgAtual.lida_at) {
                    this.$axios.post(`${this.baseUrl()}/api/portal/mensagem/marcar-lida/${m.id}`, {}, this.$store.getters.getHeaderAuth)
                        .then(() => { this.msgAtual.lida_at = new Date().toISOString(); this.contarNaoLidas(); this.load() })
                }
            })
        },

        carregarProfessores () {
            this.loadProf = true
            this.$axios.post(`${this.baseUrl()}/api/portal/mensagem/professores`, {}, this.$store.getters.getHeaderAuth)
                .then(r => { this.professores = r.data || []; this.loadProf = false })
                .catch(() => { this.loadProf = false })
        },
        abrirNova () {
            this.form = this.formVazio()
            this.carregarProfessores()
            this.modalNovaVisivel = true
        },
        abrirResposta () {
            this.form = this.formVazio()
            this.form.parent_id = this.msgAtual.id
            this.form.assunto = 'Re: ' + this.msgAtual.assunto
            // resposta vai para o professor que enviou (remetente da mensagem recebida)
            this.form.destinatario_user_id = this.msgAtual.remetente_user_id
            this.professores = this.msgAtual.remetente ? [{ id: this.msgAtual.remetente.id, name: this.msgAtual.remetente.name }] : []
            this.modalLeituraVisivel = false
            this.modalNovaVisivel = true
        },
        enviar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.baseUrl()}/api/portal/mensagem/enviar`, this.form, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Mensagem enviada.', type: 'success' })
                    this.modalNovaVisivel = false
                    this.aba = 'saida'
                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>

<style>
/* Barra de abas + botão nova mensagem */
.msg-barra {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 14px;
}
.msg-barra .msg-btn-nova { flex-shrink: 0; }

/* Lista de mensagens (cards) */
.msg-lista {
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
}
.msg-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-bottom: 1px solid #f2f2f5;
    cursor: pointer;
    transition: background .15s;
}
.msg-item:last-child { border-bottom: none; }
.msg-item:hover { background: #f5f7fa; }
.msg-item.msg-nao-lida { background: #ecf5ff; }
.msg-item-icone { font-size: 18px; padding-top: 2px; }
.msg-item-conteudo { flex: 1; min-width: 0; }
.msg-item-topo {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
}
.msg-item-pessoa {
    color: #303133;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.msg-item-data { color: #909399; font-size: 12px; white-space: nowrap; flex-shrink: 0; }
.msg-item-assunto {
    color: #409eff;
    font-size: 13px;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.msg-item.msg-nao-lida .msg-item-pessoa,
.msg-item.msg-nao-lida .msg-item-assunto { font-weight: bold; }
.msg-vazio { padding: 28px 14px; text-align: center; color: #909399; font-size: 14px; }

/* Modais adaptáveis ao mobile (o !important vence o width inline do el-dialog) */
@media (max-width: 640px) {
    .msg-dialog { width: 94% !important; margin-top: 8vh !important; }
    .msg-dialog .el-dialog__body { padding: 12px 16px; }
    .msg-barra .msg-btn-nova { flex: 1; }
}
</style>
